module.exports = __webpack_public_path__ + "static/media/splash.39456520.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apps/splash.png
// module id = 565
// module chunks = 0